/**
 * 驗證持卡人英文姓名格式
 * 規則：只允許英文字母、空格、撇號、減號、點號
 * @param value - 輸入的姓名
 * @returns 錯誤訊息，若無錯誤則返回 null
 */
export function validateCardHolderName(value: string): string | null {
  const pattern = /^[A-Za-z\s'\-.]+$/;
  const trimmedValue = value ? String(value).trim() : '';
  if (!trimmedValue) {
    return '請輸入信用卡面英文姓名，例如：DA MING WANG';
  }
  if (!pattern.test(trimmedValue)) {
    return "請輸入字母或以下字元：撇號 (')、減號 (-) 或點號 (.) 或空格";
  }
  return null;
}
